import { render, staticRenderFns } from "./ModalRenommageCommande.vue?vue&type=template&id=52ce75ac&"
import script from "./ModalRenommageCommande.vue?vue&type=script&lang=js&"
export * from "./ModalRenommageCommande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports